module.exports = __webpack_public_path__ + "static/img/8.116bb89.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/zh/8.png
// module id = Vbr/
// module chunks = 0